import { useContext } from 'react'

import { CHILD_DECREASE, CHILD_INCREASE } from '../../Constants'
import { PAXContext } from './PaxContext'
import { PaxCounter } from './PaxCounter'

/**
 * Counter for Children Pax
 */
function ChildrenCounter() {
	const [{ activeRoom = 1, costingInfo = [], totalPax }, dispatch] =
		useContext(PAXContext)
	const currentRoom = costingInfo[activeRoom - 1]
	const roomAdultCounts = currentRoom.adultCount
	const roomChildrenCount = (currentRoom.childAges || []).length
	const roomPaxCounts = roomAdultCounts + roomChildrenCount
	let disableChildIncrease =
		roomPaxCounts >= 6 || roomChildrenCount >= 4 || totalPax >= 9
	let disableChildDecrease = roomChildrenCount === 0
	return (
		<PaxCounter
			count={roomChildrenCount}
			suffixText={roomChildrenCount > 1 ? 'Children' : 'Child'}
			incrementAction={() => {
				dispatch({ type: CHILD_INCREASE, payload: {} })
			}}
			decrementAction={() => {
				dispatch({ type: CHILD_DECREASE, payload: {} })
			}}
			isDecrementDisable={disableChildDecrease}
			isIncrementDisable={disableChildIncrease}
		/>
	)
}

export default ChildrenCounter
